import React, { FC, useCallback } from "react";
import InfoIcon from "@material-ui/icons/Info";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { makeStyles, Theme, ThemeOptions } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme & ThemeOptions) => ({
  paper: {
    padding: theme.spacing(2),
    maxWidth: "600px",
    color: theme.palette.secondary.main,
    fontSize: "14px",
  },
  boxIcon: {
    color: theme.custom.color,
    width: "0.75em",
    height: "0.75em",
    verticalAlign: "top",
    cursor: "pointer",
  },
}));

interface Props {
  description: React.ReactChild; // include string
}

export const InfoIconOnClick: FC<Props> = (props: Props) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = useCallback(
    (event: React.MouseEvent<any>): void => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  const handlePopoverClose = useCallback((): void => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <>
      <InfoIcon className={classes.boxIcon} aria-describedby={id} onClick={handlePopoverOpen} />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        classes={{
          paper: classes.paper,
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        // disableRestoreFocus
      >
        <Typography variant={"body2"}>{props.description}</Typography>
      </Popover>
    </>
  );
};
